import { Form, message, Modal, Spin } from 'antd';
import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { login, magiclogin } from '../../services/api';

// import { signInWithEmailAndPassword } from 'firebase/auth';
// import { auth } from '../../utils/firebase';

export default function Login() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errors, setErrors] = useState<any>(null);
    const [Status, setStatus] = useState(false);
    const [loading, setloading] = useState(false);
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const location = useLocation()
    const { user} = useAuthContext()
    const currentQueryParams = location.search;
    const submitForm = async (event:any) => {
        event.preventDefault();
        setloading(true)
        setErrors(null)
     
 
            fetch(login, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json", 
                    "Access-Control-Allow-Credentials": "true", 
                },
                credentials: "include",
                body: JSON.stringify({ email, password }),
            }).then(res => res.json()).then((data) => {
         
                if(data.success){
                    
                    
                        navigate('/')
        
                    
                }else{
                    setErrors(data.error)
                }

            }).catch(err => setErrors('Invalid credentials')).finally(() => setloading(false))
        
      };

      useEffect(() => {
        (async () => {
            const token = searchParams.get('token')
            if(token){
    
              
                fetch(magiclogin, {
                    method: "POST",
                    headers: { 
                        "Content-Type": "application/json", 
                        "Access-Control-Allow-Credentials": "true", 
                    },
                    credentials: "include",
                    body: JSON.stringify({ token }),
                }).then(res => res.json()).then((data) => {
             
                    if(data.success){
                        
                    
                        navigate(location.state?.from?.pathname || '/' , {replace:true})
            
                      
                    }else{
                        console.log(data.error)
                    }
        
                }).catch(err => console.log('Invalid credentials')).finally(() => setloading(false))
    
            }

        })()
    }, [])


    
  return (
                      
            <Form className="flex-1 w-full">
                <div className="space-y-3 flex flex-col items-end w-full">
                    <Form.Item
                        validateStatus={errors ? "error" : ''}
                        help={errors}
                        className="group"
                        style={{ marginBottom: "0", width:'100%' }}
                        required
                        
                    >
                        <input
                        type="email"
                        placeholder={'Email'}
                        className={`rounded-lg py-2 px-3 block  w-full h-[50px] !text-[18px] placeholder:text-[18px] `}
                        value={email}
                        onChange={(e) => {
                            setEmail(e.target.value);
                            setErrors(null);
                        }}
                        required
                        />
                    </Form.Item>
                    <Form.Item
                        validateStatus={errors ? "error" : ''}
                        help={errors}
                        className="group"
                        style={{ marginBottom: "0", width:'100%' }}
                        required
                    >
                        <input
                        type="password"
                        placeholder={'Password'}
                        className="rounded-lg py-2 px-3 block  w-full h-[50px] !text-[18px] placeholder:text-[18px] "
                        value={password}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setErrors(null);
                        }}
                        required
                        />
                    </Form.Item>

                </div>
                <div className='flex space-x-4 mt-4 items-center'>
                    <Spin spinning={loading}>
                        <div className=''>
                            <button
                            className="text-level2 block  bg-gray-300 px-7 py-2.5  rounded-lg "
                            type="submit"
                            disabled={loading}
                            onClick={submitForm}
                            // style={{background: '#000'}}
                            >
                            login
                            </button>

                        </div>
                    </Spin>
                    {/* <div className='w-full flex '>
                        <p className='text-[14px] text-level2'>{t('connect:buttons.forget-password')}</p>
                    </div> */}

                </div>
            </Form>

                             
               
                
         
     
        
  )
}
